import { useState, useEffect } from 'react'
import { toaster } from '@!/components/ui/toaster'
import { getPurchaseHistoriesApi } from '@!/Api/storeBookPurchase'
import { isVisibleBook } from '@!/User/Bookshelf/util/Check'
import { useAtom } from 'jotai'
import { userHashAtom } from '@!/atoms/userInfoAtom'

export const usePurchaseHistories = () => {
  const [purchaseHistories, setPurchaseHistories] = useState(null)
  const [userHash] = useAtom(userHashAtom)

  const fetchPurchaseHistories = async (nextToken = null) => {
    if (!userHash) return

    try {
      const data = await getPurchaseHistoriesApi(nextToken)
      const currentTime = Date.parse(data.current_time)
      const filteredHistories = data.histories.filter((book) => isVisibleBook(book, currentTime))
      setPurchaseHistories((prevState) => ({
        ...prevState,
        ...data,
        histories: prevState ? [...prevState.histories, ...filteredHistories] : filteredHistories,
      }))
      return data
    } catch (error) {
      toaster.create({
        title: 'エラー',
        description: '購入履歴の取得に失敗しました。',
        type: 'error',
        duration: 9000,
        closable: true,
      })
      throw error
    }
  }

  useEffect(() => {
    if (userHash) {
      fetchPurchaseHistories()
    }
  }, [userHash])

  return [purchaseHistories, fetchPurchaseHistories]
}
